var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionLawAppSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#FFEACC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5606_27027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9 16.9C27.8 15.6 27.4 14.4 26.8 13.3C26.2 12.1 25.3 11.1 24.3 10.3C23 9.3 21.6 8.6 20 8.3C19.5 8.1 19.1 8 18.7 8C18.2 8 17.6 8 17.1 8C16.9 8 16.7 8 16.5 8.1C15.4 8.2 14.4 8.6 13.5 9.1C12.3 9.6 11.3 10.4 10.4 11.4C9.3 12.7 8.5 14.2 8.2 15.9C8.1 16.3 8 16.7 8 17.1C8 17.7 8 18.2 8 18.8C8 19 8 19.2 8.1 19.5C8.5 22 9.6 24 11.5 25.7C12.9 26.9 14.6 27.7 16.4 28C17.2 28 17.9 28 18.7 28C20.1 28 21.3 27.6 22.6 26.9C23.7 26.3 24.7 25.6 25.5 24.6C26.2 23.8 26.8 22.9 27.2 21.8C27.6 20.8 27.9 19.7 27.9 18.6C28 18.1 28 17.5 27.9 16.9ZM19.3 22.6C19.3 22 19.3 21.4 19.3 20.9C19.3 20.7 19.3 20.6 19 20.6C17.2 20.6 15.3 20.6 13.5 20.6C13.3 20.6 13.3 20.6 13.3 20.4C13.3 19.9 13.3 19.3 13.3 18.8C13.3 18.7 13.3 18.7 13.4 18.7C16.4 18.7 19.5 18.7 22.5 18.7C22.5 18.7 22.5 18.7 22.6 18.7C21.5 20 20.4 21.3 19.3 22.6ZM22.6 17.2C22.6 17.3 22.6 17.3 22.5 17.3C19.5 17.3 16.4 17.3 13.4 17.3C13.4 17.3 13.4 17.3 13.3 17.3C14.4 16 15.5 14.7 16.6 13.3C16.6 13.9 16.6 14.5 16.6 15C16.6 15.2 16.6 15.3 16.9 15.3C18.7 15.3 20.6 15.3 22.4 15.3C22.6 15.3 22.6 15.3 22.6 15.5C22.6 16.1 22.6 16.6 22.6 17.2Z",
    fill: "#FF671E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5606_27027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionLawAppSetting);
export default __webpack_public_path__ + "static/media/transaction-law-app-setting.4ffbec49453e11a34995f5343bd99c5a.svg";
export { ForwardRef as ReactComponent };